import { func, bool } from 'prop-types';
import Button from '@alltrails/shared/denali/components/Button';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import * as styles from './styles/styles.module.scss';

const FormButtons = ({ onCancel, disabled }) => {
  return (
    <div className={styles.formButtonsContainer}>
      <Button text={StringConstantsMixin.strings.CANCEL} onClick={onCancel} testId="map-creator-cancel" variant="flat" />
      <Button disabled={disabled} testId="map-creator-save" text={StringConstantsMixin.strings.SAVE} type="submit" variant="primary" width="auto" />
    </div>
  );
};

export default FormButtons;

FormButtons.propTypes = {
  onCancel: func.isRequired,
  disabled: bool
};

FormButtons.defaultProps = {
  disabled: false
};
